import { useTranslation } from "@msuite/ui/localization";
import { cn } from "@msuite/ui/utils";
import type { IncomingInvoiceCheckKey } from "@msuite/utils/incoming-invoices";
import type { IncomingInvoiceCheckListItem } from "@msuite/utils/types";
import {
	INCOMING_INVOICE_CHECK_LABEL,
	IncomingInvoiceCheckBadge,
	IncomingInvoiceCheckHint,
} from "@/components/incoming-invoices";

/** Props Interface */
interface IncomingInvoiceCheckItemProps {
	checkKey: IncomingInvoiceCheckKey;
	/** The check's last outcome, or null while the invoice has not been checked on it. */
	check: IncomingInvoiceCheckListItem | null;
	currency: string;
}

export function IncomingInvoiceCheckItem({
	checkKey,
	check,
	currency,
}: IncomingInvoiceCheckItemProps) {
	/** Context */
	const { t } = useTranslation();

	/** Computed */
	const state = check?.state ?? "unchecked";

	/** Render */
	return (
		<li
			className="h-stack items-center gap-4 px-4 last:border-b-[0.5px] first:border-t-[0.5px] border-color py-2"
			data-state={state}
			data-cy={`incoming-invoice-check-${checkKey}`}
		>
			<IncomingInvoiceCheckBadge state={state} />
			<span className={cn("flex-1", state === "skipped" && "opacity-60")}>
				{t(INCOMING_INVOICE_CHECK_LABEL[checkKey])}
			</span>
			{check && (
				<IncomingInvoiceCheckHint
					check={check}
					currency={currency}
				/>
			)}
		</li>
	);
}
